import React, { ReactNode } from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import { Grid } from '@mui/material';
import {
	Formik,
	FormikBag,
	FormikConfig,
	Form as FormikForm,
	FormikHelpers,
	FormikProps,
	FormikValues,
} from 'formik';

import { Actions } from './styled';

interface IFormProps extends Omit<FormikConfig<FormikValues>, 'onSubmit'> {
	loading?: boolean;
	hideActions?: boolean;
	onSave?: ((data: FormikValues) => void) | ((data: FormikValues) => Promise<any>);
	onSubmit?: (
		values: FormikValues,
		formikBag: FormikBag<FormikProps<FormikValues>, FormikValues>,
	) => void | Promise<any>;
	children: ReactNode | ((props: FormikProps<FormikValues>) => ReactNode);
	footer?: ReactNode | ((props: FormikProps<FormikValues>) => ReactNode);
}

function Form({
	loading,
	hideActions,
	onSave,
	children, // @TODO: children as render prop. If needed ask Andriy
	onSubmit,
	footer,
	...props
}: IFormProps) {
	const handleSubmit = async (data: FormikValues, { setErrors }: FormikHelpers<any>) => {
		try {
			await onSave(data);
		} catch (e) {
			setErrors(e.errors);
		}
	};

	return (
		<Formik
			{...props}
			onSubmit={onSave ? handleSubmit : onSubmit}
			enableReinitialize
			validateOnMount={false}
			validateOnChange={false}
		>
			{(props) => (
				<FormikForm>
					<Grid container gap="24px" direction="column">
						<Grid item width="100%">
							{typeof children === 'function' ? children(props) : children}
						</Grid>
						{/* <Errors>
							<FormAlert />
						</Errors> */}
						<Grid item>
							{typeof footer === 'function' ? footer(props) : footer}
							{!hideActions && (
								<Actions>
									<LoadingButton loading={loading} type="submit" variant="contained">
										SAVE
									</LoadingButton>
								</Actions>
							)}
						</Grid>
					</Grid>
				</FormikForm>
			)}
		</Formik>
	);
}

export default Form;
